const createQuery = () => `
  ... on CompanyLeadershipWidget {
    leadershipTeam {
      _id
      name
      slug
      jobTitle
      isVerified
      images {
        headshotv2_1x1_720 {
          url
          caption
          link
        }
        headshot_220x347_720 {
          url
          caption
          link
        }
      }
    }
  }
`

export default createQuery
